import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa"; 
import InputField from "components/fields/InputField";
import { login } from "store/features/auth/authActions";
import { selectAuthLoading } from "store/features/auth/authSelectors";
import { showSuccessToast } from "utils/toastNotification";
import { getSecureLocalItem } from "utils/secureSessionStorage";

export default function SignIn() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(selectAuthLoading);

  // Retrieve from session storage
  const role = getSecureLocalItem("role");

  const [formData, setFormData] = useState({
    phone: "",
    password: "",
  });
  
  const [showPassword, setShowPassword] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(login(formData));
  };

  if (role === "vendor") {
    navigate("/vendor/dashboard");
    showSuccessToast("Vendor Login Successfully !");
  } else if (role === "admin") {
    navigate("/admin/dashboard");
    showSuccessToast("Admin Login Successfully !");
  }

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>

        <form onSubmit={handleSubmit}>
          {/* Phone Number */}
          <InputField
            variant="auth"
            extra="mb-3"
            label="Phone Number "
            placeholder="Enter your phone"
            id="phone"
            type="tel"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          {/* Password with visibility toggle */}
          <div className="relative mb-3">
            <InputField
              variant="auth"
              label="Password "
              placeholder="Enter your password"
              id="password"
              type={showPassword ? "text" : "password"}
              value={formData.password}
              onChange={handleChange}
              required
            />
            <button
              type="button"
              className="absolute right-3 top-12 text-gray-500 hover:text-gray-700 focus:outline-none"
              onClick={togglePasswordVisibility}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </button>
          </div>

          {/* Sign In Button */}
          <button
            type="submit"
            disabled={loading}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        {/* Sign Up Link */}
        <div className="mt-4 text-center">
          <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
            Want to join as a vendor ?{" "}
          </span>
          <Link
            to="/auth/vendor-self-register"
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Register now
          </Link>
        </div>
      </div>
    </div>
  );
}